module.exports = __webpack_public_path__ + "static/media/outfit4.df09f854.jpg";